import React from "react";
import { Input } from "antd";

const Search = Input.Search;

export const TitleSearch = ({ onSearch, onChange, onPressEnter, ...props }) => (
  <div {...props}>
    <Search
      placeholder="Search name"
      allowClear 
      onSearch={onSearch}
      onChange={onChange}
      onPressEnter={onPressEnter}    
    />
  </div>
);
